import { useState, useMemo, useEffect } from "react";

import { Box, Paper, Checkbox, FormControlLabel, Button, Typography, List, ListItem,
  ListItemText, TextField, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { ModalCustom } from "../../../../components/ModalCustom";
import { Chip } from "@mui/material";

export default function ModalVarParagon({ variablesList = [], varListParagon = {}, site, openModalPar, setOpenModalPar, setParagonArray, paragonArray }) {
  const paragonVars = useMemo(() => varListParagon?.variables_list || [], [varListParagon]);

  const [selectedPrincipali, setSelectedPrincipali] = useState([]);
  const [selectedParagoni, setSelectedParagoni] = useState([]);
  const [associazioni, setAssociazioni] = useState([]);
  const [principaliDisponibili, setPrincipaliDisponibili] = useState([]);
  const [paragoniDisponibili, setParagoniDisponibili] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [nomeAssociazione, setNomeAssociazione] = useState("");
  const [coloreAssociazione, setColoreAssociazione] = useState("#" + Math.floor(Math.random()*16777215).toString(16).padStart(6, '0'));

  useEffect(() => {
    const usedPrincipali = new Set(paragonArray.flatMap(a => a.principali));
    const usedParagoni = new Set(paragonArray.flatMap(a => a.paragoni));

    const disponibiliPrincipali = variablesList.map(({ variable }) => variable).filter(v => !usedPrincipali.has(v.variable_id));
    const disponibiliParagoni = paragonVars.map(({ variable }) => variable).filter(v => !usedParagoni.has(v.variable_id));

    setAssociazioni(paragonArray);
    setPrincipaliDisponibili(disponibiliPrincipali);
    setParagoniDisponibili(disponibiliParagoni);
    setSelectedPrincipali([]);
    setSelectedParagoni([]);
  }, [variablesList, paragonVars, paragonArray]);

  const handleTogglePrincipale = (id) => {
    setSelectedPrincipali((prev) =>
      prev.includes(id) ? prev.filter((pid) => pid !== id) : [...prev, id]
    );
  };

  const handleToggleParagone = (id) => {
    setSelectedParagoni((prev) =>
      prev.includes(id) ? prev.filter((pid) => pid !== id) : [...prev, id]
    );
  };

  const handleAssocia = () => {
    if (!selectedPrincipali.length || !selectedParagoni.length) return;
    setOpenDialog(true);
  };

  const confermaAssociazione = () => {
    const nuovaAssociazione = {
      nome: nomeAssociazione,
      principali: selectedPrincipali,
      paragoni: selectedParagoni,
      color: coloreAssociazione,  
    };

    const nuove = [...associazioni, nuovaAssociazione];
    setAssociazioni(nuove);
    setParagonArray(nuove);

    setPrincipaliDisponibili((prev) =>
      prev.filter((v) => !selectedPrincipali.includes(v.variable_id))
    );
    setParagoniDisponibili((prev) =>
      prev.filter((v) => !selectedParagoni.includes(v.variable_id))
    );

    setSelectedPrincipali([]);
    setSelectedParagoni([]);
    setNomeAssociazione("");
    setColoreAssociazione("#" + Math.floor(Math.random()*16777215).toString(16).padStart(6, '0'));
    setOpenDialog(false);
  };

  const handleRimuoviAssociazione = (index) => {
    const daRimuovere = associazioni[index];
  
    setAssociazioni(prev => prev.filter((_, i) => i !== index));
    setParagonArray(prev => prev.filter((_, i) => i !== index));
  
    setPrincipaliDisponibili(prev => [
      ...prev,
      ...variablesList
        .map(v => v.variable)
        .filter(v => daRimuovere.principali.includes(v.variable_id))
    ]);
  
    setParagoniDisponibili(prev => [
      ...prev,
      ...paragonVars
        .map(v => v.variable)
        .filter(v => daRimuovere.paragoni.includes(v.variable_id))
    ]);
  };

  const principaliMap = useMemo(() => {
    const map = new Map();
    variablesList.forEach(({ variable }) => {
      map.set(variable.variable_id, variable.device_name);
    });
    return map;
  }, [variablesList]);

  const paragoniMap = useMemo(() => {
    const map = new Map();
    paragonVars.forEach(({ variable }) => {
      map.set(variable.variable_id, variable.device_name);
    });
    return map;
  }, [paragonVars]);

  const siteName = useMemo(() => {
    return site?.brand && site?.name ? `${site.brand} - ${site.name}` : "Sito principale";
  }, [site]);

  const paragonName = useMemo(() => {
    return varListParagon?.site?.brand && varListParagon?.site?.name
      ? `${varListParagon.site.brand} - ${varListParagon.site.name}`
      : "Sito paragone";
  }, [varListParagon]);

  const configModalVariables = {
    configModal: {
      defaultExpanded:true,
      sxStyle:{width: { xs: "100%", sm: "50%" }},
  }}
  ///per determinare il contrasto del testo con lo sfondo
  const isColorLight = (hexColor) => {
    const hex = hexColor.replace("#", "");
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
    // Calcolo della luminanza percepita
    const luminance = (0.299 * r + 0.587 * g + 0.114 * b);
    return luminance > 186; // soglia colore >186 = chiaro
  };

  return (
    <ModalCustom open={openModalPar} onClose={() => setOpenModalPar(false)} 
      {...configModalVariables.configModal}>
      <Grid item size={12}>
        <Typography variant="h5" gutterBottom align="center">Associazione Variabili</Typography>
        <Grid container spacing={2}>
          <Grid item size={5}>
            <Typography variant="subtitle1">Variabili {siteName}</Typography>
            <Paper variant="outlined" sx={{ maxHeight: 300, overflowY: "auto" }}>
              <List dense>
                {principaliDisponibili.map((variable) => (
                  <ListItem key={variable.variable_id} sx={{cursor: "pointer"}}
                            onClick={() => handleTogglePrincipale(variable.variable_id)}>
                    <FormControlLabel label={variable.device_name}
                                      control={<Checkbox checked={selectedPrincipali.includes(variable.variable_id)}/>}/>
                  </ListItem>
                ))}
              </List>
            </Paper>
          </Grid>
          <Grid container size={2} display="flex" alignItems="center" justifyContent="center">
            <Button variant="contained" onClick={handleAssocia}
                    disabled={!selectedPrincipali.length || !selectedParagoni.length}>
              Associa ⮂
            </Button>
          </Grid>
          <Grid item size={5}>
            <Typography variant="subtitle1">Variabili {paragonName}</Typography>
            <Paper variant="outlined" sx={{ maxHeight: 300, overflowY: "auto" }}>
              <List dense>
                {paragoniDisponibili.map((variable) => (
                  <ListItem key={variable.variable_id} sx={{ cursor: "pointer" }}
                            onClick={() => handleToggleParagone(variable.variable_id)}>
                    <FormControlLabel label={`${variable.device_name} (ID: ${variable.variable_id})`}
                                      control={<Checkbox checked={selectedParagoni.includes(variable.variable_id)}/>}/>
                  </ListItem>
                ))}
              </List>
            </Paper>
          </Grid>
        </Grid>
        <Box mt={3}>
          <Typography variant="subtitle2">Associazioni correnti:</Typography>
          <Box display="flex" flexWrap="wrap" gap={1}>
            {associazioni.map((assoc, idx) => {
              const nomiPrincipali = assoc.principali.map((id) => principaliMap.get(id)).filter(Boolean).join(", ");
              const nomiParagoni = assoc.paragoni.map((id) => paragoniMap.get(id)).filter(Boolean).join(", ");
              const label = `${assoc.nome}: ${siteName} [${nomiPrincipali}] ⮂ ${paragonName} [${nomiParagoni}]`;
              const isLight = isColorLight(assoc.color);
              return (
                <Chip key={idx} label={label}
                      onDelete={() => handleRimuoviAssociazione(idx)}
                      sx={{ backgroundColor: assoc.color, color: isLight ? "black" : "white", maxWidth: "100%" }}/>
              );
            })}
          </Box>
        </Box>
        <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
          <DialogTitle>Nuova Associazione</DialogTitle>
          <DialogContent sx={{ overflow: 'visible' }}>
            <TextField  fullWidth label="Nome Associazione" value={nomeAssociazione} sx={{ mb: 2}}
                        onChange={(e) => setNomeAssociazione(e.target.value)}/>
            <Box display="flex" alignItems="center" gap={2}>
              <Typography>Colore:</Typography>
              <input type="color" value={coloreAssociazione}
                onChange={(e) => setColoreAssociazione(e.target.value)}/>
            </Box>
            {associazioni.some(a => a.color === coloreAssociazione) && (
              <Typography color="error" fontSize="0.8rem" mt={1}>
                Colore già usato da un'altra associazione.
              </Typography>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setOpenDialog(false)}>Annulla</Button>
            <Button onClick={confermaAssociazione}
                    disabled={!nomeAssociazione.trim() || associazioni.some(a => a.color === coloreAssociazione)}>
              Conferma
            </Button>
          </DialogActions>
        </Dialog>
      </Grid>
    </ModalCustom>
  );
}




